import { render, staticRenderFns } from "./HollandReport.vue?vue&type=template&id=226d666e&scoped=true"
import script from "./HollandReport.vue?vue&type=script&lang=js"
export * from "./HollandReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226d666e",
  null
  
)

export default component.exports